import axios from '@axios';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchForms(ctx, { id, queryParams }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/forms/providers/${id}`, { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
       /*  lockedForm(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/forms/${id}/locked`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        unlockedForm(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/forms/${id}/unlocked`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }, */
    }
}